import React, { useState, useEffect } from "react";
import { Typography, Box, Container, CssBaseline, Button, Card, FormControl, InputLabel, OutlinedInput, Grid, TextField, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, CardContent, CardHeader } from "@mui/material";

const Step2Component = ({ trainers, skillCenterEquipments, styleClasses, handleBack, handleNext }) => {

return (
<form style={styleClasses.formContainer}>
<Typography variant="h6" style={styleClasses.sectionTitle}>
Sections 4:
</Typography>
<Card style={{ marginTop: "24px", padding: "16px" }}>
    <Typography variant="h6">Trainer Details</Typography>
    <TableContainer>
        <Table>
        <TableHead>
            <TableRow>
            <TableCell>First Name</TableCell>
            <TableCell>Last Name</TableCell>
            <TableCell>Middle Name</TableCell>
            <TableCell>Skill Area</TableCell>
            <TableCell>Position</TableCell>
            <TableCell>Certificate Acquired</TableCell>
            <TableCell>Year of Experience</TableCell>
            <TableCell>General Remarks</TableCell>
            </TableRow>
        </TableHead>
        <TableBody>
            {trainers.map((trainer) => (
            <TableRow key={trainer.id}>
                <TableCell>{trainer.firstName}</TableCell>
                <TableCell>{trainer.lastName}</TableCell>
                <TableCell>{trainer.middleName}</TableCell>
                <TableCell>{trainer.skill?.name}</TableCell>
                <TableCell>{trainer.isOwner ? 'Owner' : 'Staff'}</TableCell> 
                <TableCell>
                {trainer.certifications.map((cert) => cert.certificationName).join(", ")}
                </TableCell>
                <TableCell>{trainer.yearsOfExperience}</TableCell>
                <TableCell>{trainer.generalComment}</TableCell>
            </TableRow>
            ))}
        </TableBody>
        </Table>
    </TableContainer>
    </Card>
<Box mt={8}>
    
<Typography variant="h6" style={styleClasses.sectionTitle}>
Sections 5:
</Typography>
  {/* Card Box with Equipment Table */}
<Card style={{ marginTop: "24px", padding: "16px" }}>
    <Typography variant="h6">Skill Center Equipments</Typography>
<TableContainer>
<Table>
    <TableHead>
    <TableRow>
        <TableCell>Skill Area</TableCell>
        <TableCell>Equipment Name</TableCell>
        <TableCell>Total Number Available</TableCell>
        <TableCell>Remarks</TableCell>
    </TableRow>
    </TableHead>
    <TableBody>
    {skillCenterEquipments.map((equipment) => (
        <TableRow key={equipment.id}>
        <TableCell>{equipment.skill.name}</TableCell>
        <TableCell>{equipment.equipmentName}</TableCell>
        <TableCell>{equipment.equipmentUnits}</TableCell>
        <TableCell>{equipment.remark}</TableCell>
        </TableRow>
    ))}
    </TableBody>
</Table>
</TableContainer>

</Card>

</Box>

<div style={{ display: "flex", justifyContent: "flex-end", marginTop: "24px" }}>
<Box style={{ marginTop: "24px" }}>
<Button variant="outlined" color="primary" onClick={handleBack} >
    Back
</Button>
<Button variant="contained" color="primary" onClick={handleNext} style={{ marginLeft: "16px" }}>
    Next
</Button>

</Box>
</div>

</form>
);
};

export default Step2Component;
